 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLGREAT from '@/components/xhtml/great'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLDEDICATION from '@/components/xhtml/Dedication'
 import XHTMLCONTENTS from '@/components/xhtml/Contents'
 import XHTMLINTRODUCTION from '@/components/xhtml/Introduction'
 import XHTMLAPRIL28 from '@/components/xhtml/April28'
 import XHTMLAPRIL29 from '@/components/xhtml/April29'
 import XHTMLMAY1 from '@/components/xhtml/May1'
 import XHTMLMAY4 from '@/components/xhtml/May4'
 import XHTMLMAY27 from '@/components/xhtml/May27'
 import XHTMLMAY28 from '@/components/xhtml/May28'
 import XHTMLMAY29 from '@/components/xhtml/May29'
 import XHTMLMAY30 from '@/components/xhtml/May30'
 import XHTMLJUNE1 from '@/components/xhtml/June1'
 import XHTMLJUNE5 from '@/components/xhtml/June5'
 import XHTMLJUNE7 from '@/components/xhtml/June7'
 import XHTMLJUNE9 from '@/components/xhtml/June9'
 import XHTMLJUNE11 from '@/components/xhtml/June11'
 import XHTMLJUNE12 from '@/components/xhtml/June12'
 import XHTMLJUNE13 from '@/components/xhtml/June13'
 import XHTMLJUNE15 from '@/components/xhtml/June15'
 import XHTMLJUNE16 from '@/components/xhtml/June16'
 import XHTMLJUNE18 from '@/components/xhtml/June18'
 import XHTMLJUNE19 from '@/components/xhtml/June19'
 import XHTMLJUNE20 from '@/components/xhtml/June20'
 import XHTMLJUNE21 from '@/components/xhtml/June21'
 import XHTMLJUNE21A from '@/components/xhtml/June21A'
 import XHTMLJUNE23 from '@/components/xhtml/June23'
 import XHTMLJUNE25 from '@/components/xhtml/June25'
 import XHTMLJUNE26 from '@/components/xhtml/June26'
 import XHTMLJUNE27 from '@/components/xhtml/June27'
 import XHTMLJUNE28 from '@/components/xhtml/June28'
 import XHTMLJUNE29 from '@/components/xhtml/June29'
 import XHTMLJUNE30 from '@/components/xhtml/June30'
 import XHTMLJULY4 from '@/components/xhtml/July4'
 import XHTMLJULY5 from '@/components/xhtml/July5'
 import XHTMLJULY6 from '@/components/xhtml/July6'
 import XHTMLJULY8 from '@/components/xhtml/July8'
 import XHTMLJUNE10 from '@/components/xhtml/June10'
 import XHTMLJULY11 from '@/components/xhtml/July11'
 import XHTMLJULY12 from '@/components/xhtml/July12'
 import XHTMLJULY13 from '@/components/xhtml/July13'
 import XHTMLJULY14 from '@/components/xhtml/July14'
 import XHTMLJULY15 from '@/components/xhtml/July15'
 import XHTMLJULY17 from '@/components/xhtml/July17'
 import XHTMLJULY18 from '@/components/xhtml/July18'
 import XHTMLJULY19 from '@/components/xhtml/July19'
 import XHTMLJULY20 from '@/components/xhtml/July20'
 import XHTMLJULY21 from '@/components/xhtml/July21'
 import XHTMLJULY22 from '@/components/xhtml/July22'
 import XHTMLJULY23 from '@/components/xhtml/July23'
 import XHTMLJULY24 from '@/components/xhtml/July24'
 import XHTMLJULY25 from '@/components/xhtml/July25'
 import XHTMLJULY26 from '@/components/xhtml/July26'
 import XHTMLJULY29 from '@/components/xhtml/July29'
 import XHTMLJULY30 from '@/components/xhtml/July30'
 import XHTMLAUGUST1 from '@/components/xhtml/August1'
 import XHTMLAUGUST3 from '@/components/xhtml/August3'
 import XHTMLAUGUST4 from '@/components/xhtml/August4'
 import XHTMLAUGUST5 from '@/components/xhtml/August5'
 import XHTMLAUGUST6 from '@/components/xhtml/August6'
 import XHTMLAUGUST7 from '@/components/xhtml/August7'
 import XHTMLAUGUST8 from '@/components/xhtml/August8'
 import XHTMLAUGUST9 from '@/components/xhtml/August9'
 import XHTMLAUGUST10 from '@/components/xhtml/August10'
 import XHTMLAUGUST11 from '@/components/xhtml/August11'
 import XHTMLAUGUST12 from '@/components/xhtml/August12'
 import XHTMLAUGUST13 from '@/components/xhtml/August13'
 import XHTMLAUGUST14 from '@/components/xhtml/August14'
 import XHTMLAUGUST17 from '@/components/xhtml/August17'
 import XHTMLAUGUST18 from '@/components/xhtml/August18'
 import XHTMLAUGUST20 from '@/components/xhtml/August20'
 import XHTMLAUGUST21 from '@/components/xhtml/August21'
 import XHTMLAUGUST22 from '@/components/xhtml/August22'
 import XHTMLAUGUST23 from '@/components/xhtml/August23'
 import XHTMLAUGUST24 from '@/components/xhtml/August24'
 import XHTMLAUGUST25 from '@/components/xhtml/August25'
 import XHTMLAUGUST26 from '@/components/xhtml/August26'
 import XHTMLAUGUST27 from '@/components/xhtml/August27'
 import XHTMLAUGUST28 from '@/components/xhtml/August28'
 import XHTMLAUGUST29 from '@/components/xhtml/August29'
 import XHTMLAUGUST31 from '@/components/xhtml/August31'
 import XHTMLSEPTEMBER1 from '@/components/xhtml/September1'
 import XHTMLSEPTEMBER2 from '@/components/xhtml/September2'
 import XHTMLSEPTEMBER3 from '@/components/xhtml/September3'
 import XHTMLSEPTEMBER3A from '@/components/xhtml/September3A'
 import XHTMLSEPTEMBER6 from '@/components/xhtml/September6'
 import XHTMLSEPTEMBER10 from '@/components/xhtml/September10'
 import XHTMLSEPTEMBER11 from '@/components/xhtml/September11'
 import XHTMLSEPTEMBER12 from '@/components/xhtml/September12'
 import XHTMLSEPTEMBER13 from '@/components/xhtml/September13'
 import XHTMLSEPTEMBER14 from '@/components/xhtml/September14'
 import XHTMLSEPTEMBER15 from '@/components/xhtml/September15'
 import XHTMLSEPTEMBER16 from '@/components/xhtml/September16'
 import XHTMLSEPTEMBER17 from '@/components/xhtml/September17'
 import XHTMLOCTOBER5 from '@/components/xhtml/October5'
 import XHTMLOCTOBER6 from '@/components/xhtml/October6'
 import XHTMLOCTOBER8 from '@/components/xhtml/October8'
 import XHTMLOCTOBER9 from '@/components/xhtml/October9'
 import XHTMLOCTOBER10 from '@/components/xhtml/October10'
 import XHTMLOCTOBER11 from '@/components/xhtml/October11'
 import XHTMLOCTOBER12 from '@/components/xhtml/October12'
 import XHTMLOCTOBER14 from '@/components/xhtml/October14'
 import XHTMLOCTOBER15 from '@/components/xhtml/October15'
 import XHTMLOCTOBER16 from '@/components/xhtml/October16'
 import XHTMLOCTOBER17 from '@/components/xhtml/October17'
 import XHTMLOCTOBER18 from '@/components/xhtml/October18'
 import XHTMLOCTOBER20 from '@/components/xhtml/October20'
 import XHTMLOCTOBER21 from '@/components/xhtml/October21'
 import XHTMLOCTOBER23 from '@/components/xhtml/October23'
 import XHTMLOCTOBER25 from '@/components/xhtml/October25'
 import XHTMLOCTOBER26 from '@/components/xhtml/October26'
 import XHTMLOCTOBER27 from '@/components/xhtml/October27'
 import XHTMLOCTOBER28 from '@/components/xhtml/October28'
 import XHTMLOCTOBER29 from '@/components/xhtml/October29'
 import XHTMLOCTOBER30 from '@/components/xhtml/October30'
 import XHTMLOCTOBER31 from '@/components/xhtml/October31'
 import XHTMLNOVEMBER1 from '@/components/xhtml/November1'
 import XHTMLNOVEMBER2 from '@/components/xhtml/November2'
 import XHTMLNOVEMBER3 from '@/components/xhtml/November3'
 import XHTMLNOVEMBER4 from '@/components/xhtml/November4'
 import XHTMLNOVEMBER5 from '@/components/xhtml/November5'
 import XHTMLNOVEMBER6 from '@/components/xhtml/November6'
 import XHTMLNOVEMBER7 from '@/components/xhtml/November7'
 import XHTMLNOVEMBER8 from '@/components/xhtml/November8'
 import XHTMLNOVEMBER9 from '@/components/xhtml/November9'
 import XHTMLNOVEMBER12 from '@/components/xhtml/November12'
 import XHTMLNOVEMBER22 from '@/components/xhtml/November22'
 import XHTMLNOVEMBER23 from '@/components/xhtml/November23'
 import XHTMLNOVEMBER24 from '@/components/xhtml/November24'
 import XHTMLNOVEMBER25 from '@/components/xhtml/November25'
 import XHTMLNOVEMBER26 from '@/components/xhtml/November26'
 import XHTMLNOVEMBER27 from '@/components/xhtml/November27'
 import XHTMLNOVEMBER28 from '@/components/xhtml/November28'
 import XHTMLNOVEMBER30 from '@/components/xhtml/November30'
 import XHTMLDECEMBER1 from '@/components/xhtml/December1'
 import XHTMLDECEMBER2 from '@/components/xhtml/December2'
 import XHTMLDECEMBER3 from '@/components/xhtml/December3'
 import XHTMLDECEMBER4 from '@/components/xhtml/December4'
 import XHTMLDECEMBER7 from '@/components/xhtml/December7'
 import XHTMLDECEMBER8 from '@/components/xhtml/December8'
 import XHTMLDECEMBER9 from '@/components/xhtml/December9'
 import XHTMLDECEMBER10 from '@/components/xhtml/December10'
 import XHTMLDECEMBER11 from '@/components/xhtml/December11'
 import XHTMLDECEMBER12 from '@/components/xhtml/December12'
 import XHTMLDECEMBER14 from '@/components/xhtml/December14'
 import XHTMLDECEMBER15 from '@/components/xhtml/December15'
 import XHTMLDECEMBER16 from '@/components/xhtml/December16'
 import XHTMLDECEMBER17 from '@/components/xhtml/December17'
 import XHTMLDECEMBER18 from '@/components/xhtml/December18'
 import XHTMLDECEMBER20 from '@/components/xhtml/December20'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Contents",
 			"name" : "xhtml/Contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/Introduction",
 			"name" : "xhtml/Introduction",
 			"component" : XHTMLINTRODUCTION
 		},
 		{
 			"path" : "/xhtml/April28",
 			"name" : "xhtml/April28",
 			"component" : XHTMLAPRIL28
 		},
 		{
 			"path" : "/xhtml/April29",
 			"name" : "xhtml/April29",
 			"component" : XHTMLAPRIL29
 		},
 		{
 			"path" : "/xhtml/May1",
 			"name" : "xhtml/May1",
 			"component" : XHTMLMAY1
 		},
 		{
 			"path" : "/xhtml/May4",
 			"name" : "xhtml/May4",
 			"component" : XHTMLMAY4
 		},
 		{
 			"path" : "/xhtml/May27",
 			"name" : "xhtml/May27",
 			"component" : XHTMLMAY27
 		},
 		{
 			"path" : "/xhtml/May28",
 			"name" : "xhtml/May28",
 			"component" : XHTMLMAY28
 		},
 		{
 			"path" : "/xhtml/May29",
 			"name" : "xhtml/May29",
 			"component" : XHTMLMAY29
 		},
 		{
 			"path" : "/xhtml/May30",
 			"name" : "xhtml/May30",
 			"component" : XHTMLMAY30
 		},
 		{
 			"path" : "/xhtml/June1",
 			"name" : "xhtml/June1",
 			"component" : XHTMLJUNE1
 		},
 		{
 			"path" : "/xhtml/June5",
 			"name" : "xhtml/June5",
 			"component" : XHTMLJUNE5
 		},
 		{
 			"path" : "/xhtml/June7",
 			"name" : "xhtml/June7",
 			"component" : XHTMLJUNE7
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js